// lib/types/simulation.ts
// BIDIX Auction Engine v2.2 – Simulation Types
// Last Updated: 2025-01-28

/**
 * SimulationPurpose
 * 시뮬레이션 학습 목적을 나타내는 enum
 *
 * - FirstBid: 첫 입찰 연습 (기본 목적)
 * - Rights: 권리 분석 연습 (복잡한 권리 구조 중심)
 * - Profit: 수익성 분석 연습 (안전한 매물 중심)
 * - Random: 랜덤 (기존 난이도 기반 로직 사용)
 */
export enum SimulationPurpose {
  FirstBid = "first-bid",
  Rights = "rights",
  Profit = "profit",
  Random = "random",
}

/**
 * SimulationOptions
 * 시뮬레이션 생성 시 사용할 수 있는 고급 옵션들
 *
 * - stepByStepGuide: 단계별 가이드 제공 (각 섹션에서 확인할 항목과 판단 기준 안내)
 * - highRiskRights: 복잡한 권리 구조 강제 생성
 * - volatileMarket: 시세 변동성 확대 (±5% → ±15%)
 * - hiddenTenant: 임차인 정보 마스킹 처리
 */
export interface SimulationOptions {
  stepByStepGuide?: boolean;
  highRiskRights?: boolean;
  volatileMarket?: boolean;
  hiddenTenant?: boolean;
}

